/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { MdmBootstrapFieldMismatchEntryDto } from './MdmBootstrapFieldMismatchEntryDto';
import {
    MdmBootstrapFieldMismatchEntryDtoFromJSON,
    MdmBootstrapFieldMismatchEntryDtoFromJSONTyped,
    MdmBootstrapFieldMismatchEntryDtoToJSON,
    MdmBootstrapFieldMismatchEntryDtoToJSONTyped,
} from './MdmBootstrapFieldMismatchEntryDto';

/**
 * 
 * @export
 * @interface MdmBootstrapFieldMismatchRemediateResultDto
 */
export interface MdmBootstrapFieldMismatchRemediateResultDto {
    /**
     * 
     * @type {boolean}
     * @memberof MdmBootstrapFieldMismatchRemediateResultDto
     */
    success?: boolean;
    /**
     * 
     * @type {number}
     * @memberof MdmBootstrapFieldMismatchRemediateResultDto
     */
    remediatedCount?: number;
    /**
     * 
     * @type {number}
     * @memberof MdmBootstrapFieldMismatchRemediateResultDto
     */
    remainingCount?: number;
    /**
     * 
     * @type {Array<MdmBootstrapFieldMismatchEntryDto>}
     * @memberof MdmBootstrapFieldMismatchRemediateResultDto
     */
    remainingMismatches?: Array<MdmBootstrapFieldMismatchEntryDto>;
    /**
     * 
     * @type {string}
     * @memberof MdmBootstrapFieldMismatchRemediateResultDto
     */
    message?: string;
    /**
     * 
     * @type {string}
     * @memberof MdmBootstrapFieldMismatchRemediateResultDto
     */
    errorMessage?: string;
}

/**
 * Check if a given object implements the MdmBootstrapFieldMismatchRemediateResultDto interface.
 */
export function instanceOfMdmBootstrapFieldMismatchRemediateResultDto(value: object): value is MdmBootstrapFieldMismatchRemediateResultDto {
    return true;
}

export function MdmBootstrapFieldMismatchRemediateResultDtoFromJSON(json: any): MdmBootstrapFieldMismatchRemediateResultDto {
    return MdmBootstrapFieldMismatchRemediateResultDtoFromJSONTyped(json, false);
}

export function MdmBootstrapFieldMismatchRemediateResultDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): MdmBootstrapFieldMismatchRemediateResultDto {
    if (json == null) {
        return json;
    }
    return {
        
        'success': json['success'] == null ? undefined : json['success'],
        'remediatedCount': json['remediatedCount'] == null ? undefined : json['remediatedCount'],
        'remainingCount': json['remainingCount'] == null ? undefined : json['remainingCount'],
        'remainingMismatches': json['remainingMismatches'] == null ? undefined : ((json['remainingMismatches'] as Array<any>).map(MdmBootstrapFieldMismatchEntryDtoFromJSON)),
        'message': json['message'] == null ? undefined : json['message'],
        'errorMessage': json['errorMessage'] == null ? undefined : json['errorMessage'],
    };
}

export function MdmBootstrapFieldMismatchRemediateResultDtoToJSON(json: any): MdmBootstrapFieldMismatchRemediateResultDto {
    return MdmBootstrapFieldMismatchRemediateResultDtoToJSONTyped(json, false);
}

export function MdmBootstrapFieldMismatchRemediateResultDtoToJSONTyped(value?: MdmBootstrapFieldMismatchRemediateResultDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'success': value['success'],
        'remediatedCount': value['remediatedCount'],
        'remainingCount': value['remainingCount'],
        'remainingMismatches': value['remainingMismatches'] == null ? undefined : ((value['remainingMismatches'] as Array<any>).map(MdmBootstrapFieldMismatchEntryDtoToJSON)),
        'message': value['message'],
        'errorMessage': value['errorMessage'],
    };
}

